import { createSelector } from 'reselect';

const objectDestructionSelect = ({ taps: { transportDestruction } }) => transportDestruction;

export const selectODPdfLink = createSelector(objectDestructionSelect, (searchPayment) =>
  searchPayment.getIn(['submit', 'data', 'pdf']),
);

export const selectSubmitData = createSelector(objectDestructionSelect, (objectDestruction) =>
  objectDestruction.getIn(['submit', 'data']),
);

export const selectDraftData = createSelector(objectDestructionSelect, (objectDestruction) =>
  objectDestruction.getIn(['draftData', 'data']),
);

export const selectDraftDataError = createSelector(objectDestructionSelect, (objectDestruction) =>
  objectDestruction.getIn(['draftData', 'error']),
);

export const selectODCardId = createSelector(objectDestructionSelect, (searchPayment) =>
  searchPayment.getIn(['submit', 'data', 'cardId']),
);

export const selectODSubmitError = createSelector(objectDestructionSelect, (searchPayment) =>
  searchPayment.getIn(['submit', 'error']),
);
export const selectODConfirmError = createSelector(objectDestructionSelect, (searchPayment) =>
  searchPayment.getIn(['confirm', 'error']),
);

export const selectODSubmitValidate = createSelector(objectDestructionSelect, (searchPayment) =>
  searchPayment.getIn(['submit', 'validate']),
);
